/**
 * 全局常量、方法封装模块
 * 通过原型挂载到Vue属性
 * 通过 this.Global 调用
 */

// 后台管理系统服务器地址
// export const baseUrl = 'http://139.196.87.48:8001'
// let host = window.location.host;
//   console.log("host: " ,host)
//   if (host.indexOf(":")){
//     host = host.split(":")[0];
//   }
// export const baseUrl = 'http://192.168.1.251:18010'

// export const baseUrl = "http://tiantai.ezhenmai.com/"

// export const baseUrl = 'https://www.ezhenmai.cn'
// export const baseUrl = 'http://10.4.11.82:18010'
   export const baseUrl = 'http://www.sth.com'
   // export const baseUrl = 'http://www.hzwlgj.cn'
// export const baseUrl = 'http://192.168.3.16:18011'
// export const baseUrl = 'http://'+ window.location.host +':18010'
// export const baseUrl = "http://192.168.56.106:18010";
// export const baseUrl = "http://yth-his.diandianys.com";
// 系统数据备份还原服务器地址
// export const backupBaseUrl = 'http://139.196.87.48:8002'
// export const backupBaseUrl = 'http://localhost:8002'

const CONFIG = {
  // 开发环境配置  https://www.yuhangyy.com/image/335852198412141419.jpg
  development: {
    baseUrl: 'http://www.hzwlgj.cn',
    //微信小程序配置
    appid: 'wx77c3aacbff45b6a7',
    secret: 'f1c81a521e9cb5e1a42baa0578bf8e09',
    token: '2158518m9s',
    aesKey: 'LVVXY5cbJxKhunwuA0unkCCQjbCCVUmJC7Iw2MncWpo',
    msgDataFormat: 'JSON',
    multiAgency: false
  },
  // 生产环境配置
  production: {
    baseUrl: 'http://www.hzwlgj.cn',
    // baseUrl: 'http://www.ezhenmai.com',
    //微信小程序配置
    appid: 'wx77c3aacbff45b6a7',
    secret: 'f1c81a521e9cb5e1a42baa0578bf8e09',
    token: '2158518m9s',
    aesKey: 'LVVXY5cbJxKhunwuA0unkCCQjbCCVUmJC7Iw2MncWpo',
    msgDataFormat: 'JSON',
    multiAgency: false
  }
}

export default CONFIG[process.env.NODE_ENV];



// WEBPACK FOOTER //
// ./src/common/global.js